import styled from '@emotion/styled'
import shouldForwardProp from '@styled-system/should-forward-prop'
import { ElementType, MouseEventHandler } from 'react'

import {
  BackgroundProps,
  BorderProps,
  BorderRadiusProps,
  BoxShadowProps,
  ColorProps,
  FlexboxProps,
  GridProps,
  LayoutProps,
  OpacityProps,
  OverflowProps,
  PositionProps,
  SpaceProps,
  TypographyProps,
  background,
  border,
  borderRadius,
  boxShadow,
  color,
  flexbox,
  grid,
  layout,
  mergeStyles,
  opacity,
  overflow,
  position,
  space,
  typography,
} from '../utils/styled-system'

/**
 * @deprecated
 */
export const box = (props: BoxProps) => ({
  backgroundColor: props.backgroundColor,
  boxSizing: props.boxSizing,
  cursor: props.cursor,
  display: 'flex',
  flexDirection: 'column',
  userSelect: props.userSelect,
  whiteSpace: props.whiteSpace,
  ...boxBase(props),
})

export const boxBase = (props: BoxProps) =>
  mergeStyles([
    background(props),
    border(props),
    borderRadius(props),
    boxShadow(props),
    color(props),
    flexbox(props),
    grid(props),
    layout(props),
    opacity(props),
    overflow(props),
    position(props),
    space(props),
    typography(props),
  ])

export type BoxProps = BoxBaseProps & {
  as?: ElementType
  background?: string
  backgroundColor?: string
  boxSizing?: string
  className?: string
  cursor?: string
  onClick?: MouseEventHandler
  onMouseDown?: MouseEventHandler
  onMouseEnter?: MouseEventHandler
  onMouseMove?: MouseEventHandler
  onMouseUp?: MouseEventHandler
  title?: string
  userSelect?: 'none'
  whiteSpace?: 'nowrap'
}

export type BoxBaseProps = BackgroundProps &
  OpacityProps &
  BorderProps &
  BorderRadiusProps &
  BoxShadowProps &
  ColorProps &
  FlexboxProps &
  GridProps &
  LayoutProps &
  OverflowProps &
  PositionProps &
  SpaceProps &
  TypographyProps

/**
 * @deprecated use <Div /> instead
 */
export const Box = styled('div', {
  shouldForwardProp,
})<BoxProps>(box)
